"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/APIKeys/components/APIKeyMenu.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _icons = require('web/screens/Inbox/InboxList/icons');
var _RowMenu = require('web/screens/Inbox/InboxList/Item/RowMenu'); var _RowMenu2 = _interopRequireDefault(_RowMenu);







/* A key's ⋯ button (F-17): Change expiry (Set expiry for one that never
 * expires) and Revoke, in the inbox row's menu. Revoke still asks first. */
const APIKeyMenu = ({ apiKey, onChangeExpiry, onRevoke }) => {
  const [isOpen, setIsOpen] = _react.useState.call(void 0, false)
  const buttonRef = _react.useRef(null)
  const onClose = _react.useCallback.call(void 0, (returnFocus) => {
    setIsOpen(false)
    if (returnFocus) _optionalChain([buttonRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.focus, 'call', _3 => _3()])
  }, [])
  const items = _react.useMemo(() => [
    { key: 'expiry', label: apiKey.ExpiresAt ? 'Change expiry' : 'Set expiry', onSelect: () => onChangeExpiry(apiKey) },
    { key: 'revoke', label: 'Revoke', isDestructive: true, onSelect: () => onRevoke(apiKey) },
  ], [apiKey, onChangeExpiry, onRevoke])
  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('button', {
        ref: buttonRef,
        type: "button",
        className: "settings--org-api-keys--more",
        'aria-label': `More actions for ${apiKey.Name}`,
        'aria-haspopup': "menu",
        'aria-expanded': isOpen,
        onClick: () => setIsOpen(o => !o), __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}

        , _react2.default.createElement(_icons.MoreIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}} )
      )
      ,  isOpen && _react2.default.createElement(_RowMenu2.default, { anchorRef: buttonRef, items: items, label: `Actions for ${apiKey.Name}`, onClose: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}} ) 
    )
  )
}

exports. default = APIKeyMenu
